export default class TipoSelo {

  constructor(tipoSelo, id, descricao, cor, codAbnote) {
    this.id = tipoSelo ? tipoSelo.id : id;
    this.descricao = tipoSelo ? tipoSelo.descricao : descricao;
    this.cor = tipoSelo ? tipoSelo.cor : cor;
    this.codAbnote = tipoSelo ? tipoSelo.codAbnote : codAbnote;
  }
  
}



// WEBPACK FOOTER //
// ./src/domain/selo/tipo-selo.js